import { render, staticRenderFns } from "./VoiceSettings.vue?vue&type=template&id=508af666&scoped=true"
import script from "./VoiceSettings.vue?vue&type=script&lang=js"
export * from "./VoiceSettings.vue?vue&type=script&lang=js"
import style0 from "./VoiceSettings.vue?vue&type=style&index=0&id=508af666&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508af666",
  null
  
)

export default component.exports